// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.connectButtonList {
  flex-direction: column;
  display: flex;
  gap: 1em;
  max-width: 18em;
  margin: 3em auto;
  .button {
    padding: 0.6em;
  }
}

.connectButtonBeta {
  text-transform: uppercase;
  margin: 0 0.5em;
  font-size: 0.5em;
  padding: 0.6em 0.5em 0.5em;
  display: inline-block;
  background: #ccc;
  border-radius: 0.5em;
  line-height: 0.7;
  position: relative;
  top: -0.1em;
  color: var(--primary-color);
  font-weight: bold;
  font-size: 0.7em;
}
`, "",{"version":3,"sources":["webpack://./src/frontend/components/Connect.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,aAAa;EACb,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB;IACE,cAAc;EAChB;AACF;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":[".connectButtonList {\n  flex-direction: column;\n  display: flex;\n  gap: 1em;\n  max-width: 18em;\n  margin: 3em auto;\n  .button {\n    padding: 0.6em;\n  }\n}\n\n.connectButtonBeta {\n  text-transform: uppercase;\n  margin: 0 0.5em;\n  font-size: 0.5em;\n  padding: 0.6em 0.5em 0.5em;\n  display: inline-block;\n  background: #ccc;\n  border-radius: 0.5em;\n  line-height: 0.7;\n  position: relative;\n  top: -0.1em;\n  color: var(--primary-color);\n  font-weight: bold;\n  font-size: 0.7em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
